import { BaseAPIConfig } from "@eres/api";

const defApi = new BaseAPIConfig( "https", "devgate.dubailand.gov.ae", "bcs", "integration" );

export const BcsConfig =
	{
		api: () => defApi,
	};
